import { useState } from 'react';
import {
  AgxButton,
  AgxGlobalSearch,
  AgxPanel,
  AgxSpacer,
  AgxTypography,
  Icon_Link,
  SearchResultType,
  useDialog,
} from '@urbanx/agx.ui-components2';
import {
  useGetRexDisconnectionCampaignDetails,
  useInvalidateUseGetRexDisconnectionCampaignDetails,
} from '@urbanx/agx.support.client';
import Panel from 'components/panel/Panel';
import LoadingState from 'components/loadingState/LoadingState';
import SupportBackButton from '../SupportBackButton';
import DisconnectRexListingDialog from './DisconnectRexListingDialog';

export default function RexDisconnection() {
  const [campaignId, setCampaignId] = useState('');
  const { data, isPending, isError } = useGetRexDisconnectionCampaignDetails(
    campaignId,
    !!campaignId
  );
  const invalidate = useInvalidateUseGetRexDisconnectionCampaignDetails();
  const dialog = useDialog(DisconnectRexListingDialog);

  return (
    <AgxSpacer gap="spacing-xl" fill>
      <SupportBackButton />
      <Panel title="Disconnect Rex listing">
        <AgxSpacer gap="spacing-xl" fill>
          <AgxGlobalSearch
            searchForCampaigns
            searchForArchivedCampaigns
            onItemSelected={(type, item) => {
              if (
                type !== SearchResultType.ActiveCampaign &&
                type !== SearchResultType.ArchivedCampaign
              )
                return;
              if (!item.campaignId) throw new Error('The search result has no campaign ID.');
              setCampaignId(item.campaignId);
            }}
          />
          {campaignId && isPending && <LoadingState />}
          {isError && (
            <AgxTypography id="rex-disconnection-load-error" type="body" size="small">
              Unable to load the Rex connection.
            </AgxTypography>
          )}
          {data && (
            <>
              <AgxTypography id="rex-disconnection-campaign" type="body" size="medium">
                <strong>{data.propertyAddress}</strong>
              </AgxTypography>
              <AgxTypography id="rex-disconnection-campaign-id" type="body" size="small">
                Campaign ID: {data.campaignId}
              </AgxTypography>
              {data.listings.length === 0 && (
                <div style={{ alignSelf: 'flex-start' }}>
                  <AgxPanel bodyPadding="spacing-lg">
                    <AgxSpacer
                      direction="horizontal"
                      gap="spacing-md"
                      contentAlignment="center"
                      role="status"
                    >
                      <Icon_Link width={18} height={18} />
                      <AgxTypography
                        id="rex-disconnection-empty"
                        type="body_ui_strong"
                        size="small"
                      >
                        Rex disconnected
                      </AgxTypography>
                    </AgxSpacer>
                  </AgxPanel>
                </div>
              )}
              {data.listings.map((listing) => (
                <AgxSpacer key={listing.listingId} gap="spacing-lg" contentAlignment="start" fill>
                  <AgxTypography id={`rex-listing-${listing.listingId}`} type="body" size="medium">
                    Rex listing {listing.listingId}
                  </AgxTypography>
                  <AgxButton
                    id={`disconnect-rex-${listing.listingId}`}
                    variant="primary"
                    text="Disconnect"
                    onClick={() =>
                      dialog.open({
                        campaign: data,
                        listing,
                        onDisconnected: () => invalidate(data.campaignId),
                      })
                    }
                  />
                </AgxSpacer>
              ))}
              <AgxButton
                id="refresh-rex-connection"
                text="Refresh status"
                variant="hollow"
                onClick={() => invalidate(data.campaignId)}
              />
            </>
          )}
        </AgxSpacer>
      </Panel>
    </AgxSpacer>
  );
}
